import { reportsService } from './reports.service';
import { ReportsActions, ReportsMutations, ReportsGetters } from './reports.keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import i18n from '@/i18n';

export const reportFieldsMapping = {
  'All Clients Stops Linda Faizal': ['Start Date'],
  'ANNUAL IBM Wages Paid': ['Start Date', 'Client'],
  ATT: ['Date Range'],
  'Gross Profit': ['Branch'],
  'Gross Profit (IBM_Kyndryl)': ['Branch', 'Client'],
  'Timesheet Status': ['Date Range', 'Branch'],
  'Processed Hours': ['Date Range', 'Branch'],
  'IMAC Work Permit': ['Date Range'],
  'Work Permit': ['Date Range'],
  'IBM_Kyndryl Active': ['Date Range', 'Client'],
  'Gross Profit (IBM_Kyndryl Randstad Toronto)': ['Client'],
  'IBM_Kyndryl Core Vendor': ['Date Range', 'Client'],
  'Devon Rohl Contractor': ['Client'],
  'Stops Ottawa': ['Date Range']
};

export const reportClients = [
  { name: 'IBM', client_reference_number: 'J7NM7N' },
  { name: 'Kyndryl', client_reference_number: '4PQP48' }
];

export const getInitialState = () => {
  return {
    reportsForUser: [],
    generatedReports: [],
    fields: reportFieldsMapping,
    reportClients,
    selectedSearchParams: {
      selectedReport: '',
      reportInputFields: []
    },
    reportEntitlements: null,
    isReportInProgress: false
  };
};
export const reportsStore = {
  state: getInitialState(),
  getters: {
    [ReportsGetters.ReportsForUser]: state => state.reportsForUser,
    [ReportsGetters.UserGeneratedReport]: state => state.generatedReports,
    [ReportsGetters.Fields]: state => state.fields,
    [ReportsGetters.IsReportInProgress]: state => state.isReportInProgress,
    [ReportsGetters.ReportClients]: state => state.reportClients,
    [ReportsGetters.ReportEntitlements]: state => state.reportEntitlements
  },
  mutations: {
    [ReportsMutations.SetReportsForUser](state, reports) {
      state.reportsForUser = reports;
    },
    [ReportsMutations.SetUserGeneratedReport](state, reports) {
      state.generatedReports = reports;
    },
    [ReportsMutations.UpdateReportInProgress](state) {
      state.isReportInProgress = !state.isReportInProgress;
    },
    [ReportsMutations.SetReportEntitlements](state, reportEntitlements) {
      state.reportEntitlements = reportEntitlements;
    }
  },
  actions: {
    [ReportsActions.RetrieveReportsForUser]({ commit }) {
      reportsService.getReportsForUser().then(reports => {
        commit(ReportsMutations.SetReportsForUser, reports);
      });
    },
    [ReportsActions.RetrieveUserGeneratedReport]({ commit }) {
      reportsService.getUserGeneratedReports().then(reports => {
        commit(ReportsMutations.SetUserGeneratedReport, reports);
      });
    },
    [ReportsActions.RetrieveUserReportEntitlements]({ commit }) {
      reportsService.getUserReportEntitlements().then(entitlements => {
        commit(ReportsMutations.SetReportEntitlements, entitlements);
      });
    },
    [ReportsActions.RunReport]({ dispatch, commit }, reportParams) {
      commit(ReportsMutations.UpdateReportInProgress);
      reportsService
        .runReport(reportParams)
        .then(status => {
          dispatch(ReportsActions.RetrieveUserGeneratedReport);
          dispatch(TolMessagesActions.SetMessages, status);
          commit(ReportsMutations.UpdateReportInProgress);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('reports.errors.run_report')
          });
        });
    }
  }
};
